import Api from "@/Api.js";

export default {

    redeemCouponForIndia(couponCode){
        const url = '/api/secure/purchase/packages?giftCode=' + couponCode;
        return Api.put(url,{});
    },

    redeemCoupon(couponCode){
        const url = '/api/secure/purchase/packages?giftCode=' + couponCode;
        return Api.put(url,{});
    },

    oneTimePackages(){
        const url = '/api/secure/portal/subscription-packages';
        return Api.get(url);
    },
    


     

}